import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Spinner } from '@trinity/chat-components/components/presentation/Spinner.js';
import { getAuthProvider } from '@/auth/auth-provider';
import * as $session from '@/auth/session';
import * as $sessionHttp from '@/auth/session-http';
import { config } from '@/config';
import { actions } from '@/store/actions';

export const LogoutScreen = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync: logoutAsync } = useMutation({
    mutationFn: () => {
      return $sessionHttp.logout();
    },
    onSuccess: res => {
      // Check if user logged in via Trinity Edge
      const lastLoginStrategy = $session.getLastLoginStrategy();


      if (lastLoginStrategy?.strategy === 'enterprise' && lastLoginStrategy?.identifier === 'trinity-edge') {
        getAuthProvider().logout(false);
        window.location.replace(config().TRINITY_EDGE_BASE_URL);
        return;
      }


      Sentry.setUser(null);
      dispatch(actions.userLoggedOutAction());
      queryClient.cancelQueries()
        .then(() => {
          queryClient.clear();
        });

      if (!res.wasAuthenticated) {
        return navigate('/', { replace: true });
      }

      const redirectPath = '/_login';
      navigate(redirectPath, { replace: true });
    },
  });

  useEffect(() => {
    setTimeout(() => {
      logoutAsync();
    }, 500);
  }, []);

  return (
    <Root>
      <Spinner />
    </Root>
  );
};

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: `calc(100vh - var(--navbar-height))`,
});
